// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"437":"6fe6e146","495":"3d27002d","556":"eb8c5231","660":"d8094db7","775":"c0e6dd65","979":"b156caef"}[chunkId] + ".css";
};